export default "__VITE_ASSET__DKxB2Ue8__"